import { forwardRef, HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const DropdownList = forwardRef<
  HTMLUListElement,
  HTMLAttributes<HTMLUListElement>
>(({ className, ...props }, ref) => (
  <ul
    className={cn('max-h-48 overflow-y-auto', className)}
    ref={ref}
    {...props}
  />
))
